module.exports = __webpack_public_path__ + "img/cerebro-axis.064be209.png";